export const getCustomerId = (): string => {
    const userInStorage = sessionStorage.getItem("user");
    if(userInStorage) {
        return  JSON.parse(userInStorage.toString()).customerId;
    }
    throw "customerId is not found!"
};